export const FETCH_WALLET_DETAILS = "FETCH_WALLET_DETAILS";

export const fetchWallet = (provider, signer, account) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_WALLET_DETAILS, provider, signer, account });
    } catch (error) {
      console.log(error.message);
    }
  };
};
